import { getRequest, postRequest } from '../baseRequest'
import { filterEmptyParams } from '@/utils/formatObject'

// 分页查询行动规则列表
export const getWorkOrderLogicList = (data) => postRequest('/workOrderLogic/list', filterEmptyParams(data))
// 保存行动规则
export const createWorkOrderLogic = (data) => postRequest('/workOrderLogic/create', data)
// 编辑行动规则
export const updateWorkOrderLogic = (data) => postRequest('/workOrderLogic/update', data)
// 查询行动规则详情
export const getWorkOrderLogicDetail = (id) => getRequest(`/workOrderLogic/detail/${id}`)
// 启用行动规则
export const enableWorkOrderLogic = (id) => getRequest(`/workOrderLogic/enable/${id}`)
// 禁用行动规则
export const disableWorkOrderLogic = (id) => getRequest(`/workOrderLogic/disable/${id}`)
// 查询全部用户列表
export const querySimpleUserList = (data) => getRequest('/workOrderLogic/querySimpleUserList',data)
